function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "javascript",
  d: "M0,0v2500h2500V0H0z M1360.5,1949.9c0,243.3-142.6,354.1-350.7,354.1c-187.9,0-297-97.3-352.4-214.8l0,0 l191.3-115.8c36.9,65.4,70.5,120.8,151,120.8c77.2,0,125.9-30.2,125.9-147.7v-798.8h234.9V1949.9z M1916,2304 c-218.2,0-359.1-104-427.9-240l0,0l191.3-110.8c50.4,82.2,115.8,142.6,231.6,142.6c97.4,0,159.4-48.7,159.4-115.8 c0-80.5-63.8-109.1-171.2-156.1l-58.7-25.2c-169.5-72.1-281.9-162.8-281.9-354.1c0-176.2,134.2-310.5,344-310.5 c149.4,0,256.8,52,333.9,188l-182.9,117.5c-40.3-72.2-83.9-100.7-151-100.7c-68.8,0-112.4,43.6-112.4,100.7 c0,70.5,43.6,99,144.3,142.7l58.7,25.2c199.7,85.6,312.1,172.9,312.1,369.2C2305.3,2188.2,2139.2,2304,1916,2304z"
});

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.1f7f822a.svg";
export { ForwardRef as ReactComponent };